import { render, staticRenderFns } from "./robot0.vue?vue&type=template&id=57dacf8c&scoped=true&"
import script from "./robot0.vue?vue&type=script&lang=js&"
export * from "./robot0.vue?vue&type=script&lang=js&"
import style0 from "./robot0.vue?vue&type=style&index=0&id=57dacf8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dacf8c",
  null
  
)

export default component.exports